/**
 * @module playerManager
 * @private
 */

import { sessionId, localUserId, profile_id } from "../../store";

let youboraPlugin = null;
let libLoaded = false;
const errorCodesIgnore = [
  "1400",
  "3011",
  "9000",
  "3017",
  "2007",
  "1023",
  "1301",
  "3024",
  "1202",
  "3000",
  "3006",
  "1016",
  "3002",
  "2008",
  "2009",
  "3016",
  "1204",
  "2006",
  "3023",
  "1208",
  "1200",
  "1000",
  "1103",
  "1012",
  "2003",
  "3032",
  "errorcode"
];
function getQuality(has4K) {
  return has4K ? "4K" : "HD";
}

async function getYouboraOptions(config) {
  const profileId = await profile_id.get(this);

  let assetOwnership = Array.isArray(config.contentOwnership) ? config.contentOwnership[0] : config.contentOwnership;

  return {
    username: config.userid ? config.userid : localStorage.getItem("globalUserId"),
    "content.transactionCode": config.id,
    "content.title": config.playbackAnalytics.title,
    "content.isLive": config.isLive || false,
    "content.duration": config.playbackAnalytics.duration,
    "content.resource": config.manifest,
    "content.id": config.id,
    "content.autoplay": config?.autoplay, //1
    "content.profileType": config.profileType, //2
    "content.fullscreenMode": config?.fullscreen, //3
    "content.subscriptionType": config.contentType, //4
    "content.assetOwnership": assetOwnership, //config.contentOwnership, //5
    "content.assetType": config.assetType, //6
    "content.freeToAir": config.freeToAir === true ? config.freeToAir : false, //7 FVod
    "content.profile_id": profileId, //8 MP
    "content.customDimension.1": config.addonContent,
    "content.customDimension.2": config.onlineContent,
    "content.customDimension.3": config.contentType,
    "content.metadata": {
      content_metadata: {
        title: config.playbackAnalytics.title,
        genre: config.playbackAnalytics.genre,
        language: this.lang,
        parental: this.parentalLevel,
        duration: config.playbackAnalytics.duration,
        mediaGuid: config.playbackAnalytics.mediaGuid,
        app_version: this.publicVersion,
        app_build_version: this.appVersion,
        sdk_build_version: this.version,
        sessionId: sessionId.get(),
        autoplay: config?.autoplay, //1
        profileType: config.profileType, //2
        fullscreenMode: config?.fullscreen, //3
        subscriptionType: config.contentType, //4
        assetOwnership: assetOwnership, //config.contentOwnership, //5
        assetType: config.assetType, //6
        freeToAir: config.freeToAir === true ? config.freeToAir : false, //7 Fvod
        profile_id: profileId, //8 MP
        season: config.playbackAnalytics.season,
        episode: config.playbackAnalytics.episode,
        play_from: config.playbackAnalytics.playFrom,
        resume: !!config.playbackAnalytics.resume ? "yes" : "no",
        rec_variant: config.rec_variant,
        current_screen: config.current_screen,
        previous_screen: config.previous_screen,
        referring_carousel_id: config.referring_carousel_id,
        title_id: config.title_id,
        guid: config.guid,
        platform: config.platform,
        bitmovinError: config.bitmovinError // 9 Bitmovin error
      },
      device: {
        manufacturer: this.device.getManufacturer(),
        type: this.device.getType(),
        year: await this.device.getYear(),
        firmware: await this.device.getFirmwareVersion(),
        smartHub: await this.device.getServerVersion(),
        duid: await this.device.getId(),
        modelName: await this.device.getRealModel()
      },
      filename: config.manifest,
      content_type: config.contentTypeYoubora,
      quality: getQuality(config.playbackAnalytics.is4KEnabled)
    },
    rec_variant: config.rec_variant,
    current_screen: config.current_screen,
    previous_screen: config.previous_screen,
    referring_carousel_id: config.referring_carousel_id,
    title_id: config.title_id,
    guid: config.guid,
    platform: config.platform
  };
}

const adapters = {
  tizen: () => new youbora.adapters.SamsungAvplay("av-player"), //Tizen 2015 and 2016
  webmaf: () => new youbora.adapters.PsWebmaf(),
  bitmovin: player => new youbora.adapters.Bitmovin8(player) // Hisense ,Tizen 2017 and above and LG
};
export default {
  /**
   *
   * @param {String} adapter name of the youbora adapter
   */
  initialize(adapter, player) {
    youboraPlugin === null &&
      (youboraPlugin = new youbora.Plugin({
        accountCode: this.playbackAnalytics.accountCode,
        enabled: this.playbackAnalytics.enableAnalytics,
        httpSecure: this.playbackAnalytics.httpSecure,
        "errors.ignore": errorCodesIgnore
      })) &&
      youboraPlugin.setAdapter(adapters[adapter](player));
  },

  resetAdapter(adapter, player) {
    try {
      //youboraPlugin.disable();
      youboraPlugin.removeAdapter(adapters[adapter](player));
    } catch (e) {}
    try {
      //youboraPlugin.enable();
      youboraPlugin.setAdapter(adapters[adapter](player));
    } catch (e) {}
  },

  /**
   * Loads the url of youbora lib
   * @param {String} src Lib url
   */
  loadYouboraLib(src, onload) {
    if (!libLoaded) {
      const s = document.createElement("script");
      s.setAttribute("src", src);
      s.addEventListener("load", onload);
      document.body.appendChild(s);
      libLoaded = true;
      return true;
    } else {
      return false;
    }
  },

  /**
   * Sets options for current content
   * @param {Object} options
   */
  async setOptions(options) {
    let optionsYou = await getYouboraOptions.call(this, options);
    youboraPlugin && youboraPlugin.setOptions(optionsYou);
  },

  /**
   * Sends a youbora event
   * @param {Function} eventCallback Youbora callback
   * @param {Number} errorCode Error code
   * @param {String} errorMessage Error message
   */
  sendEvent(eventCallback, errorCode = null, errorMessage = null) {
    youboraPlugin &&
      youboraPlugin.getAdapter() &&
      youboraPlugin.getAdapter()[eventCallback] &&
      youboraPlugin.getAdapter()[eventCallback](errorCode, errorMessage);
  },

  /**
   * Returns youbora plugin instance
   */
  getYouboraPlugin() {
    return youboraPlugin;
  },
  /* Youbora events */
  events: {
    init: "fireInit",
    start: "fireStart",
    pause: "firePause",
    resume: "fireResume",
    stop: "fireStop",
    seekBegin: "fireSeekBegin",
    seekEnd: "fireSeekEnd",
    bufferBegin: "fireBufferBegin",
    bufferEnd: "fireBufferEnd",
    join: "fireJoin",
    error: "fireError",
    endedHandler: "endedHandler"
  }
};
